import { render, staticRenderFns } from "./chridMenu.vue?vue&type=template&id=0f5ef1e6"
import script from "./chridMenu.vue?vue&type=script&lang=js"
export * from "./chridMenu.vue?vue&type=script&lang=js"
import style0 from "./chridMenu.vue?vue&type=style&index=0&id=0f5ef1e6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports